<template>  
    <div class="clock">  
      <h2>{{ currentTimeString }}</h2>  
    </div>  
  </template>  
    
  <script>  
  export default {  
    data() {  
      return {  
        currentTime: new Date(),  
      };  
    },  
    computed: {  
      currentTimeString() {  
        const hours = this.currentTime.getHours().toString().padStart(2, '0');  
        const minutes = this.currentTime.getMinutes().toString().padStart(2, '0');  
        const seconds = this.currentTime.getSeconds().toString().padStart(2, '0');  
        const year = this.currentTime.getFullYear();  
        const month = (this.currentTime.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以需要+1  
        const day = this.currentTime.getDate().toString().padStart(2, '0');  
        const date = `${year}-${month}-${day}`; // 例如：2023-03-15 // 使用浏览器的本地日期格式  
        return `${date} ${hours}:${minutes}:${seconds}`;  
      },  
    },  
    mounted() {  
      this.tick();  
    },  
    methods: {  
      tick() {  
        setInterval(() => {  
          this.currentTime = new Date(); // 更新当前时间  
        }, 1000);  
      },  
    },  
  };  
  </script>  
    
  <style scoped>  
  .clock {  
    text-align: center;  
    font-size: 2rem;  
    font-family: Arial, sans-serif;  
    color: #fff;
  }  
  </style>